import { getAPI } from 'requests/api';

export const ATTEMPTS_STATUS_MAP = new Map([
  ['unknown', 'Desconhecida'],
  ['started', 'Iniciada'],
  ['evaluation_started', 'Em correção'],
  ['pending_evaluation', 'Aguardando correção'],
  ['evaluated', 'Corrigida'],
  ['passed', 'Aprovada'],
  ['failed', 'Reprovada'],
  ['scored', 'Nota calculada']
]);

export const ASSIGNMENT_KIND_MAP = {
  regular: 'Atividade regular',
  final: 'Atividade de recuperação',
  replacement: 'Atividade substitutiva'
};

export const translateAssignmentAttemptStatus = (status: string) => {
  return ATTEMPTS_STATUS_MAP.get(status);
};

export const fetchAssignmentsAttemptsLogs = async (attemptId: string) => {
  const { data } = await getAPI().get(
    `/admin/assignments/attempts/${attemptId}/logs`
  );

  return data;
};
